import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/TeacherProfilePage.css';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoKidola from '../assets/Logo Kidola PNG.png';
import ttd from '../assets/TTD Miss Jeane.png';
import QRCode from 'qrcode'; 

const TeacherSalaryPage = ({isSidebarCollapsed}) => {
    const { teacherId } = useParams(); 
    const [teacher, setTeacher] = useState(null);
    const [extraTime, setExtraTime] = useState([]);
    const [salaryHistory, setSalaryHistory] = useState([]);        
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false); 
    
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTeacherDetails = async () => {
            try {
                const response = await api.get(`/teacher/salaryDetail/${teacherId}`);
                setTeacher(response.data.data.teacherData || null);
                setExtraTime(response.data.data.extraTimeData || null);
                setSalaryHistory(response.data.data.salaryHistory || null);
            } catch (error) {
                console.error("Failed to fetch teacher details", error);
            }
        };
        fetchTeacherDetails();
    }, [teacherId]);

    useEffect(() => {
        if (teacher) {
            const total = calculateTotalHarga();
            setPaymentAmount(total); 
        }
    }, [teacher]);

    if (!teacher) return <p>Loading teacher salary details...</p>;

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const convertNumberToWordsID = (number) => {
        const satuan = ['', 'Satu', 'Dua', 'Tiga', 'Empat', 'Lima', 'Enam', 'Tujuh', 'Delapan', 'Sembilan', 'Sepuluh', 'Sebelas'];
        if (number < 12) return satuan[number];
        if (number < 20) return convertNumberToWordsID(number - 10) + ' Belas';
        if (number < 100) return convertNumberToWordsID(Math.floor(number / 10)) + ' Puluh ' + convertNumberToWordsID(number % 10);
        if (number < 200) return 'Seratus ' + convertNumberToWordsID(number - 100);
        if (number < 1000) return convertNumberToWordsID(Math.floor(number / 100)) + ' Ratus ' + convertNumberToWordsID(number % 100);
        if (number < 2000) return 'Seribu ' + convertNumberToWordsID(number - 1000);
        if (number < 1000000) return convertNumberToWordsID(Math.floor(number / 1000)) + ' Ribu ' + convertNumberToWordsID(number % 1000);
        if (number < 1000000000) return convertNumberToWordsID(Math.floor(number / 1000000)) + ' Juta ' + convertNumberToWordsID(number % 1000000);
        return 'Angka terlalu besar';
    };

    const handlePrintSalarySlip = async () => {
        if (!paymentDate) {
            alert('Isi Payment Date dulu sebelum mencetak slip gaji!');
            return;
        }
    
        const doc = new jsPDF();
    
        // Header
        doc.addImage(logoKidola, 'PNG', 170, 9, 30, 30, undefined, 'FAST'); // Insert Logo
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text('Yayasan Anak Kidola Hebat', 14, 15);
        doc.setFont('helvetica', 'normal');
        doc.text('KIDOLA LEARNING CENTRE', 14, 22);
        doc.setFontSize(8);
        doc.text('Nomor AHU: 0011273.AH.01.04.Tahun 2024', 14, 27);
        doc.text('Pusat: Jl. Mandor Hasan No.21A RT.005 RW.004, Ceger, Cipayung Jakarta Timur', 14, 32);
        doc.text('Telepon: 0897-6622-100 & 0898-8614-505', 14, 37);
    
        // Garis bawah header
        doc.setLineWidth(0.5);
        doc.line(14, 42, 196, 42);
    
        // Title
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('SLIP GAJI', 105, 55, null, null, 'center');
    
        // Info Guru
        doc.setFontSize(12);
        doc.setFont('helvetica', 'normal');
        const infoStartY = 65;
        const labelX = 14;
        const valueX = 60;
        const roleName = teacher.User?.Role?.name || 'Guru';
    
        doc.text('Nomor Induk', labelX, infoStartY);
        doc.text(':', labelX + 40, infoStartY);
        doc.text(teacher.teacher_code, valueX, infoStartY);
    
        doc.text('Nama', labelX, infoStartY + 8);
        doc.text(':', labelX + 40, infoStartY + 8);
        doc.setFont('helvetica', 'bold');
        doc.text(teacher.teacher_name.toUpperCase(), valueX, infoStartY + 8);
    
        doc.setFont('helvetica', 'normal');
        doc.text('Jabatan', labelX, infoStartY + 16);
        doc.text(':', labelX + 40, infoStartY + 16);
        doc.text(roleName.toUpperCase(), valueX, infoStartY + 16);
    
        doc.text('Cabang', labelX, infoStartY + 24);
        doc.text(':', labelX + 40, infoStartY + 24);
        doc.text((teacher.Branch ? teacher.Branch.branch_name : "CENTRAL").toUpperCase(), valueX, infoStartY + 24);
    
        doc.text('Periode', labelX, infoStartY + 32);
        doc.text(':', labelX + 40, infoStartY + 32);
        doc.text(moment(paymentDate).format('MMMM YYYY'), valueX, infoStartY + 32);
    
        // Garis putus-putus
        doc.setLineWidth(0.1);
        doc.setDrawColor(0);
        for (let i = 14; i < 200; i += 3) {
            doc.line(i, infoStartY + 42, i + 1, infoStartY + 42);
        }
    
        const salaryRows = [
            [
              'Gaji Pokok', 
              { content: 'Rp', styles: { halign: 'right' } }, 
              { content: formatCurrency(teacher.salary), styles: { halign: 'right' } }
            ],
        ];
        extraTime.forEach(item => {
            salaryRows.push([
              item.type_name,
              { content: 'Rp', styles: { halign: 'right' } },
              { content: formatCurrency(item.fee), styles: { halign: 'right' } }
            ]);
        });
        salaryRows.push([
            { content: 'Total', styles: { fontStyle: 'bold' } },
            { content: 'Rp', styles: { halign: 'right', fontStyle: 'bold' } },
            { content: formatCurrency(calculateTotalHarga()), styles: { halign: 'right', fontStyle: 'bold' } }
        ]);
          
        autoTable(doc, {
            startY: infoStartY + 50,
            head: [['Deskripsi', '', 'Pendapatan']],
            body: salaryRows,
            theme: 'grid',
            styles: { fontSize: 12, textColor: [0, 0, 0], font: 'helvetica' },
            headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
            columnStyles: {
              1: { cellWidth: 10, halign: 'center' },  // Rp center
              2: { halign: 'right' }                   // Nominal rata kanan
            },
            didDrawCell: (data) => {
              if (data.section === 'head' && (data.column.index === 1 || data.column.index === 2)) {
                data.cell.text = ''; // Hapus header kolom tengah (Rp)
              }
              if (data.section === 'body' && data.column.index === 2) {
                data.cell.styles.lineWidth = { left: 0 }; // Ini yang hapus garis kiri antara Rp dan Nominal
              }
            }
        });
          
          
          
        
    
        // Terbilang
        const finalY = doc.lastAutoTable.finalY + 10;
        const terbilangText = convertNumberToWordsID(paymentAmount).trim();
        doc.setFontSize(11);
        doc.text(`Terbilang : ${terbilangText} Rupiah`, 14, finalY);
    
        // Kota dan Tanggal
        doc.text(`Jakarta, ${moment(paymentDate).format('DD MMMM YYYY')}`, 14, finalY + 20);
    
        // Signature
        doc.addImage(ttd, 'PNG', 14, finalY + 25, 50, 20);
    
        doc.setFontSize(12);
        doc.text('Miss Jeane  -  Principal', 14, finalY + 50);
    
        // QRCode
        const slipID = `${teacher.teacher_code}_${moment(paymentDate).format('YYYYMM')}`;
        const qrCodeDataURL = await QRCode.toDataURL(slipID);
        doc.addImage(qrCodeDataURL, 'PNG', 160, finalY + 20, 30, 30);
    
        doc.save(`SalarySlip_${teacher.teacher_name}_${moment(paymentDate).format('YYYYMMDD')}.pdf`);
    };
    

    function getFeeAmount(extraFees, typeName) {
        // Pastikan extraFees adalah array
        if (!Array.isArray(extraFees)) {
            return 0; // Kembalikan 0 jika bukan array
        }
        const fee = extraFees.find(fee => fee.Type.type_name === typeName);
        return fee ? fee.fee_amount : 0; 
    }

    const formatNumber = (number) => {
        return Number(number).toLocaleString('id-ID', { maximumFractionDigits: 0 });
    };

    const calculateTotalHarga = () => {       
        const totalSalary = extraTime.reduce((total, item) => {
          return item.fee > 0 ? total + Number(item.fee) : total;
        }, 0);

        const total = totalSalary + Number(teacher.salary);    
        //setPaymentAmount(total);
        return total;
    };

    const validateForm = () => {
        const errors = {};
    
        if (!paymentMethod) errors.payment_method = 'Payment Method is required';
        if (!paymentDate) errors.paymentDate = 'Payment Date is required';
        if (paymentAmount==0) errors.paymentAmount = 'Payment amount is required';
        
        return errors;
    };

    const handleSubmit = async (event) => {
        
        event.preventDefault();
        const validationErrors = validateForm();

        if (isSubmitting) return;  
  
        

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
        
            // Mempersiapkan data untuk dikirim
            const transferData = {
                data: {
                    teacherData: teacher,
                    extraTimeData: extraTime,
                    salaryData: {
                        purchase_date: paymentDate,
                        purchase_amount: paymentAmount,
                        purchase_method: paymentMethod
                    }

                },
            };
            console.log(transferData);
            setIsSubmitting(true);
            try {
                const response = await api.post('/teacher/salary/save', transferData); 
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
                
            } catch (error) {
                console.error('Error submitting data:', error);
                console.error('Error adding/updating teacher:', error);     
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            } finally {  
                setIsSubmitting(false); // Reset status pengiriman  
            } 
        }

        
    };

    const currentMonth = moment().month() + 1; // moment() mengembalikan bulan 0-11
    const currentYear = moment().year();

    // Cek apakah gaji untuk bulan berjalan sudah ada
    const hasSalaryForCurrentMonth = salaryHistory.some(history => {
        return history.salary_month === currentMonth && history.salary_year === currentYear;
    });
  


    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
            <div className="page-title">Teacher Salary Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Teacher Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>:</td>
                                <td>{teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>NIK</td>
                                <td>:</td>
                                <td>{teacher.teacher_code}</td>
                            </tr>
                            <tr>
                                <td>Role</td>
                                <td>:</td>
                                <td>{teacher.User.Role.name}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{teacher.Branch ? teacher.Branch.branch_name : "CENTRAL"}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Salary Data</h3>
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th className='table-right-align'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SALARY</td>
                                    <td className='table-right-align'>{formatCurrency(teacher.salary)}</td>
                                </tr>
                                {extraTime.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.type_name}</td>
                                        <td className='table-right-align'>{formatCurrency(item.fee)}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td><strong>TOTAL SALARY</strong></td>
                                    <td className='table-right-align'><strong>{formatNumber(calculateTotalHarga())}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {salaryHistory.length > 0 &&
                <div className="section">
                    <h3 className="section-header">Salary History Data</h3>
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th className='table-right-align'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {salaryHistory.map((history, index) => (
                                    <tr key={index}>
                                        <td>{moment().month(history.salary_month-1).year(history.salary_year).format('MMMM YYYY')}</td>
                                        <td className='table-right-align'>{formatCurrency(history.total_salary)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                }
                {!hasSalaryForCurrentMonth && (
                <div className="section">
                    <h3 className="section-header">Payment Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>                                
                                <tr>
                                    <td>
                                        <label>Payment Amount</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={formatCurrency(paymentAmount)}                                             
                                            readOnly
                                            />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Date</label>
                                    </td>
                                    <td>
                                        <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>{errors.paymentDate && <td><div className="error-message">{errors.paymentDate}</div></td>}</tr>
                                <tr>
                                    <td>
                                        <label>Payment Method</label>
                                    </td>
                                    <td>
                                        <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} >
                                            <option key="" value="">Choose Payment Method</option>
                                            <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                            <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>{errors.payment_method && <td><div className="error-message">{errors.payment_method}</div></td>}</tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="search-container">
                        <button className="profile-button" onClick={handlePrintSalarySlip}>Print Salary Slip</button>
                    </div>
                    <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Pay Salary</button>
                    </div>
                </div>
                 )}
                <div className="search-container">
                    <button className="profile-button" onClick={() => navigate('/teacher/list')}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default TeacherSalaryPage;
